import { z } from 'zod';

/**
 * Anexos do mes de cada banco, ao lado do OFX.
 *
 * O OFX alimenta os lancamentos; estes dois sao so o documento que o banco
 * emite, guardado para conferencia e para a contabilidade. Um de cada por
 * banco e por mes — reenviar substitui.
 */
export const TIPOS_ANEXO_EXTRATO = ['extrato_bancario', 'extrato_cartao'] as const;
export const tipoAnexoExtrato = z.enum(TIPOS_ANEXO_EXTRATO);
export type TipoAnexoExtrato = z.infer<typeof tipoAnexoExtrato>;

export const ROTULO_ANEXO_EXTRATO: Record<TipoAnexoExtrato, string> = {
  extrato_bancario: 'Extrato bancário',
  extrato_cartao: 'Extrato do cartão',
};

export const ANEXO_EXTRATO_MAX_BYTES = 25 * 1024 * 1024;

/** PDF e foto: e o que o internet banking exporta ou o que sai de um print. */
export const ANEXO_EXTRATO_EXTENSOES: Record<string, string> = {
  pdf: 'application/pdf',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
};

export const anexoExtrato = z.object({
  tipo: tipoAnexoExtrato,
  month_key: z.string(),
  file_name: z.string(),
  file_size: z.number().int().nonnegative(),
  uploaded_by_name: z.string().nullable(),
  uploaded_at: z.string(),
});
export type AnexoExtrato = z.infer<typeof anexoExtrato>;

export type AnexosDoMes = Record<TipoAnexoExtrato, AnexoExtrato | null>;
